module.exports = __webpack_public_path__ + "img/Firewall.398439d.svg";